import React from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './primitives';
import { LOGO } from '../media';
import { CONTACT_HREF } from '../content';
export const NAV = [{
  label: 'Our Mission',
  href: '#mission'
}, {
  label: 'Five Essentials',
  href: '#essentials'
}, {
  label: 'How It Works',
  href: '#how'
}, {
  label: 'Support Us',
  href: '#support'
}];

/* FIXED: in the Lovable build the hamburger icon was not a menu. It was an
   anchor to #connect, so the entire navigation was unreachable on a phone.
   This is a real disclosure: focus trapped, Escape closes, body scroll locked,
   and aria-expanded reflects state. */

export function SiteHeader() {
  const [open, setOpen] = React.useState(false);
  const panelRef = React.useRef<HTMLDivElement>(null);
  const toggleRef = React.useRef<HTMLButtonElement>(null);
  React.useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setOpen(false);
        toggleRef.current?.focus();
        return;
      }
      if (e.key !== 'Tab' || !panelRef.current) return;
      const focusable = panelRef.current.querySelectorAll<HTMLElement>('a[href], button:not([disabled])');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    panelRef.current?.querySelector<HTMLElement>('a[href]')?.focus();
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);
  return <header className="sticky top-0 z-50 w-full border-b border-border/60 bg-background/95 backdrop-blur-md" data-id="element-214" data-mp="1czl17sl16xam">
      <div className="section-shell flex h-28 items-center justify-between gap-4" data-id="element-215" data-mp="102es4mlovn0l">
        <a href="#top" className="min-w-0 shrink" aria-label="Vitality Foundation home" data-id="element-216" data-mp="100aom5rpcq0u">
          <img src={LOGO} alt="Vitality Foundation" className="h-16 w-auto max-w-full object-contain object-left sm:h-20" data-id="element-217" data-mp="1et43pq32b44z" />
        </a>

        <nav aria-label="Primary" className="hidden shrink-0 items-center gap-7 text-[11px] font-semibold lg:flex" data-id="element-218" data-mp="m2vtckerpo0y">
          {NAV.map(item => <a key={item.href} href={item.href} className="hover:text-primary" data-id="element-219" data-mp="w12z073lwjnn">
              {item.label}
            </a>)}
          <Button href={CONTACT_HREF} data-id="element-220" data-mp="r0npxrqcxybh">Get in touch</Button>
        </nav>

        <button ref={toggleRef} type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="shrink-0 rounded-md p-2 lg:hidden" data-id="element-221" data-mp="27exccgb1hczo">
          {open ? <X data-id="element-222" data-mp="2f0990ltbcqpr" /> : <Menu data-id="element-223" data-mp="2f00w4tx6xlek" />}
        </button>
      </div>

      {open && <div id="mobile-nav" ref={panelRef} className="border-t border-border bg-background lg:hidden" data-id="element-224" data-mp="20zq4hoo242sc">
          <nav aria-label="Primary mobile" className="section-shell flex flex-col gap-1 py-6" data-id="element-225" data-mp="251k1nmz1monr">
            {NAV.map(item => <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="border-b border-border/60 py-4 font-serif text-h4" data-id="element-226" data-mp="2ssyy4z452br3">
                {item.label}
              </a>)}
            <div className="pt-6" data-id="element-227" data-mp="2ny31flnyj07n">
              <Button href={CONTACT_HREF} className="w-full" onClick={() => setOpen(false)} data-id="element-228" data-mp="3bpqnnqa9xn3l">
                Get in touch
              </Button>
            </div>
          </nav>
        </div>}
    </header>;
}